import { useState, useEffect, useReducer, useCallback } from "react";
import { Button, Card, Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import DataGrid from "../../components/dataGrid/DataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import QueryString from "qs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import moment from "moment";
// import { Edit } from "react-feather";

import {
  exportExcelPreDispatches,
  getPreDispatches,
  updatePreDispatches,
} from "../../services/preDispatch.service";
import moment from "moment";
import { Check, Edit2 } from "react-feather";
import toast from "react-hot-toast";
import FormInput from "../../components/FormInput";
import FormSelect from "../../components/FormSelect";
import { getTransporters } from "../../services/transporters.service";
import { updateInvoice } from "../../services/invoice.service";
// import { exportExcelParty } from "../../services/parties.service";
import { Formik } from "formik";
import { validationSchema } from "../../validations/preDispatch.validation";

const initialState = {
  data: [],
  page: 1,
  limit: 100,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 100,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

function PreDispatchReports() {
  const [filterData, setFilterData] = useState({
    orderNumber: "",
    invoiceNumber: "",
    orderFrom: "",
    orderTo: "",
  });
  const [modal, setModal] = useState(false);
  const [transporterModal, setTransporterModal] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
  const [selectedTransporter, setSelectedTransporter] = useState<any>(null);

  const toggle = () => setModal(!modal);
  const toggleTransporterModal = () => {
    setTransporterModal(!transporterModal);
  };

  const [selectedRows, setSelectedRows] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [data, dispatch] = useReducer(reducer, initialState);
  const location = useLocation();
  const navigate = useNavigate();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };

  const parseDateValue = (value: unknown) => {
    if (typeof value !== "string" || !value) {
      return null;
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  useEffect(() => {
    const { page, orderNumber, invoiceNumber, orderFrom, orderTo } = query;
    setFilterData({
      orderNumber: typeof orderNumber === "string" ? orderNumber : "",
      invoiceNumber: typeof invoiceNumber === "string" ? invoiceNumber : "",
      orderFrom: typeof orderFrom === "string" ? orderFrom : "",
      orderTo: typeof orderTo === "string" ? orderTo : "",
    });

    if (!modal) {
      setLoading(true);
      getPreDispatches({ page, orderNumber, invoiceNumber, orderFrom, orderTo })
        .then((response: any) => {
          setData(response.data);
        })
        .catch(() => {})
        .finally(() => {
          setLoading(false);
        });
    }
  }, [location.search, modal]);
  const handleRowSelected = useCallback((state: any) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleFilter = () => {
    const queryParams: any = { ...query, page: 1, ...filterData };

    Object.keys(queryParams).forEach((key) => {
      if (!queryParams[key]) {
        delete queryParams[key];
      }
    });

    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}${Object.keys(queryParams).length > 0 ? "?" + queryString : ""}`);
  };
  const handleClearFilter = () => {
    setFilterData({ orderNumber: "", invoiceNumber: "", orderFrom: "", orderTo: "" });
    const queryParams = { page: 1 };
    const queryString = QueryString.stringify(queryParams);
    navigate(`${location.pathname}?${queryString}`);
  };

  function calculateTotals(data: any) {
    const uniqueParties = new Set();
    const uniqueInvoiceNumbers = new Set();
    let totalBox = 0;
    let invoiceAmount = 0;

    for (const item of data) {
      uniqueParties.add(item.party.name);
      uniqueInvoiceNumbers.add(item.invoiceNumber);
      totalBox += item.checkedNumberOfBox;
      invoiceAmount += item.invoiceAmount;
    }

    return {
      totalParty: uniqueParties.size,
      totalInvoice: uniqueInvoiceNumbers.size,
      totalPicklist: data.length,
      totalBox,
      invoiceAmount,
    };
  }

  const openTransporterModal = (row: any) => {
    setSelectedInvoice(row);
    setSelectedTransporter(row.transporter || row.party?.transporter || null);
    setTransporterModal(true);
  };

  const handleTransporterUpdate = () => {
    if (!selectedInvoice?.id || !selectedTransporter?.id) {
      toast.error("Please select transporter.");
      return;
    }

    updateInvoice(selectedInvoice.id, { transporter: selectedTransporter.id })
      .then(() => {
        const updatedResults = data.results.map((invoice: any) => {
          if (invoice.id !== selectedInvoice.id) {
            return invoice;
          }

          return {
            ...invoice,
            transporter: selectedTransporter,
          };
        });

        const updatedSelectedRows = selectedRows.map((invoice: any) => {
          if (invoice.id !== selectedInvoice.id) {
            return invoice;
          }

          return {
            ...invoice,
            transporter: selectedTransporter,
          };
        });

        setData({ ...data, results: updatedResults });
        setSelectedRows(updatedSelectedRows);
        setTransporterModal(false);
        toast.success("Transporter updated.");
      })
      .catch(() => {
        toast.error("Failed to update transporter.");
      });
  };

  const columns = [
    {
      selector: (row: any) => row.serialNumber,
      name: "S.No.",
      sortable: false,
      maxWidth: "70px",
      minWidth: "70px",
    },
    {
      selector: (row: any) => row.party?.name || "",
      name: "Party Name",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => row.orderNumber,
      name: "Order No.",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => moment(row.orderDate).format("DD-MM-YYYY"),
      name: "Order Date",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => row.invoiceNumber,
      name: "Invoice No.",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => moment(row.invoiceDate).format("DD-MM-YYYY"),
      name: "Invoice Date",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) =>
        row.mixItem ? `${row.checkedNumberOfBox} (Mixed)` : row.checkedNumberOfBox,
      name: "Invoice Box",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => row.party?.city?.name || "",
      name: "City",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => row.transporter?.name || row.party?.transporter?.name || "",
      name: "Transporter Name",
      sortable: false,
      wrap: true,
    },
    {
      selector: (row: any) => {
        return <>{row.VOR ? <Check strokeWidth={3} className='text-success' /> : ""}</>;
      },
      name: "VOR",
      sortable: false,
      wrap: true,
      maxWidth: "65px",
      minWidth: "65px",
    },
    {
      selector: (row: any) => (
        <Button
          size='sm'
          color='link'
          className='p-0 text-primary'
          onClick={() => openTransporterModal(row)}
        >
          <Edit2 size={15} />
        </Button>
      ),
      name: "Action",
      sortable: false,
      center: true,
      maxWidth: "80px",
      minWidth: "80px",
    },
  ];

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2 page-title-row'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Pre Dispatch Report</h1>
        </Col>
      </Row>

      <div className='flex-grow-1 overflow-hidden' style={{ height: "calc(100vh - 230px)" }}>
        <Card className='h-100 p-3 w-100 '>
          <div className='d-flex flex-column h-100 rounded-0 list-data-grid-wrapper'>
            <DataGrid
              columns={columns}
              data={data}
              loading={loading}
              isFilterApplied={Object.keys(query).some((key) => key !== "page")}
              noDataTitle='No pre dispatch records found'
              noDataSubtitle='There are no pre dispatch records available right now.'
              noDataFilteredTitle='No pre dispatch records match your filters'
              noDataFilteredSubtitle='Try changing or clearing the filter criteria.'
              filterByDate={true}
              FilterSubHeader={true}
              filterData={filterData}
              setFilterData={setFilterData}
              selectableRows={true}
              onSelectedRowsChange={handleRowSelected}
              pagination={false}
              fixedHeader={true}
              subHeaderComponent={
                <Row className='w-100 align-items-start g-3 py-1 px-1'>
                  <Col md={2}>
                    <FormInput
                      name='orderNumber'
                      label='Order Number'
                      placeholder='Order Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.orderNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      name='invoiceNumber'
                      label='Invoice Number'
                      placeholder='Invoice Number'
                      onChange={(e) =>
                        setFilterData({
                          ...filterData,
                          [e.target.name]: e.target.value,
                        })
                      }
                      value={filterData.invoiceNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <div
                      className='form-label'
                      style={{ fontSize: "0.875rem", fontWeight: 500, marginBottom: "0.375rem" }}
                    >
                      Date Range
                    </div>
                    <DatePicker
                      selectsRange
                      startDate={parseDateValue(filterData.orderFrom)}
                      endDate={parseDateValue(filterData.orderTo)}
                      onChange={(dates: [Date | null, Date | null]) => {
                        const [startDate, endDate] = dates;
                        setFilterData({
                          ...filterData,
                          orderFrom: startDate ? moment(startDate).format("YYYY-MM-DD") : "",
                          orderTo: endDate ? moment(endDate).format("YYYY-MM-DD") : "",
                        });
                      }}
                      isClearable
                      dateFormat='dd/MM/yyyy'
                      className='form-control'
                      placeholderText='Select date range'
                    />
                  </Col>

                  <Col md='auto'>
                    <div className='filter-action-buttons'>
                      <Button color='primary' size='sm' onClick={() => handleFilter()}>
                        Filter
                      </Button>
                      <Button color='danger' size='sm' onClick={() => handleClearFilter()}>
                        Clear
                      </Button>
                    </div>
                  </Col>
                  {/* <Col md={2} className='mt-1'>
                    <div className='mt-4 text-end'>
                      <Button
                        color='primary'
                        size='sm'
                        onClick={() => {
                          exportExcelParty()
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Party Master.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col> */}
                  {selectedRows.length > 0 ? (
                    <Col md='auto'>
                      <div className='filter-export-button'>
                        <Button
                          color='primary'
                          size='sm'
                          onClick={() => {
                            toggle();
                          }}
                        >
                          Process
                        </Button>
                      </div>
                    </Col>
                  ) : (
                    ""
                  )}
                </Row>
              }
            />
          </div>
        </Card>
      </div>

      <Modal isOpen={modal} toggle={toggle} fullscreen>
        <ModalHeader toggle={toggle}>Pre Dispatch Report</ModalHeader>
        <ModalBody></ModalBody>
      </Modal>

      <Modal isOpen={transporterModal} toggle={toggleTransporterModal}>
        <ModalHeader toggle={toggleTransporterModal}>Update Transporter</ModalHeader>
        <ModalBody>
          <FormSelect
            id='transporter'
            name='transporter'
            label='Transporter'
            isAsync
            getOptions={getTransporters}
            defaultFilter={{ status: true }}
            onChange={(_: any, value: any) => {
              setSelectedTransporter(value);
            }}
            value={selectedTransporter}
            isClearable
          />
          <div className='d-flex justify-content-end gap-2'>
            <Button size='sm' color='secondary' onClick={toggleTransporterModal}>
              Cancel
            </Button>
            <Button size='sm' color='primary' onClick={handleTransporterUpdate}>
              Update
            </Button>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={modal} toggle={toggle} fullscreen>
        <ModalHeader toggle={toggle}>Pre Dispatch Report</ModalHeader>
        <ModalBody>
          <Formik
            initialValues={{
              route: "",
              driverName: "",
              vehicleNumber: "",
              dispatchDate: new Date().toISOString().split("T")[0],
            }}
            validationSchema={validationSchema}
            onSubmit={(values) => {
              updatePreDispatches({
                items: selectedRows,
                grNumber: values.route,
                driverName: values.driverName,
                vehicleNumber: values.vehicleNumber,
                dispatchDate: values.dispatchDate,
                ...calculateTotals(selectedRows),
              })
                .then((response) => {
                  toast.success("Pre dispatch report submitted.");
                  navigate(`/dispatch-report/print/${response.data.id}`);
                  // const url = `/dispatch-report/print/${response.data.id}`;
                  // window.open(url, "_blank");

                  toggle();
                })
                .catch(() => {});
            }}
          >
            {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
              <>
                <Row>
                  <Col md={2}>
                    <FormInput
                      label='Route'
                      name='route'
                      placeholder='Route'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.route}
                      error={errors.route}
                      touched={touched.route}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      label='Driver Name'
                      name='driverName'
                      placeholder='Driver Name'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.driverName}
                      error={errors.driverName}
                      touched={touched.driverName}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      label='Vehicle No.'
                      name='vehicleNumber'
                      placeholder='Vehicle No.'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.vehicleNumber}
                      error={errors.vehicleNumber}
                      touched={touched.vehicleNumber}
                    />
                  </Col>
                  <Col md={2}>
                    <FormInput
                      label='Dispatch Date'
                      name='dispatchDate'
                      type='date'
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.dispatchDate}
                      error={errors.dispatchDate}
                      touched={touched.dispatchDate}
                    />
                  </Col>
                  <Col md='auto'>
                    <div className='filter-action-buttons'>
                      <Button color='primary' size='sm' onClick={() => handleSubmit()}>
                        Submit
                      </Button>
                      <Button
                        color='danger'
                        size='sm'
                        onClick={() => {
                          const ids = selectedRows.map((selectedRow: any) => selectedRow.id);
                          exportExcelPreDispatches({ ids })
                            .then((response) => {
                              const blobURL = URL.createObjectURL(response.data);
                              const anchor = document.createElement("a");
                              anchor.href = blobURL;
                              anchor.download = "Pre Dispatch.xlsx";
                              anchor.click();
                              URL.revokeObjectURL(blobURL);
                            })
                            .catch(() => {
                              toast.error("Record not found to export.");
                            });
                        }}
                      >
                        Export
                      </Button>
                    </div>
                  </Col>
                  <Col md={2}></Col>
                </Row>
              </>
            )}
          </Formik>
          <DataGrid
            columns={columns}
            data={{ results: selectedRows }}
            isFilterApplied={false}
            noDataTitle='No selected rows'
            noDataSubtitle='Select at least one row to process pre dispatch.'
            noDataFilteredTitle='No selected rows'
            noDataFilteredSubtitle='Select at least one row to process pre dispatch.'
            filterByDate={true}
            FilterSubHeader={true}
            filterData={filterData}
            setFilterData={setFilterData}
            pagination={false}
            // subHeaderComponent={
            //   <Row>
            //     <Col md={2}>
            //       <FormInput
            //         name='grNumber'
            //         label='GR No.'
            //         placeholder='GR No.'
            //         onChange={(e) =>
            //           setFilterData({
            //             ...filterData,
            //             [e.target.name]: e.target.value,
            //           })
            //         }
            //         value={filterData.orderNumber}
            //       />
            //     </Col>
            //     <Col md={2}>
            //       <FormInput
            //         name='driverName'
            //         label='Driver Name'
            //         placeholder='Driver Name'
            //         onChange={(e) =>
            //           setFilterData({
            //             ...filterData,
            //             [e.target.name]: e.target.value,
            //           })
            //         }
            //         value={filterData.invoiceNumber}
            //       />
            //     </Col>
            //     <Col md={2}>
            //       <FormInput
            //         name='invoiceDate'
            //         label='Vehicle No.'
            //         placeholder='Vehicle No.'
            //         onChange={(e) =>
            //           setFilterData({
            //             ...filterData,
            //             [e.target.name]: e.target.value,
            //           })
            //         }
            //         value={filterData.invoiceDate}
            //       />
            //     </Col>

            //     <Col md={2}>
            //       <FormInput
            //         name='invoiceDate'
            //         label='Dispatch Date'
            //         placeholder='Dispatch Date'
            //         type='date'
            //         onChange={(e) =>
            //           setFilterData({
            //             ...filterData,
            //             [e.target.name]: e.target.value,
            //           })
            //         }
            //         value={filterData.invoiceDate}
            //       />
            //     </Col>

            //     <Col md={2} className='mt-1'>
            //       <div className='mt-4'>
            //         <Button
            //           color='primary'
            //           size='sm'
            //           className='me-2'
            //           onClick={() => {
            //             updatePreDispatches({
            //               items: selectedRows,
            //               grNumber: "123",
            //               driverName: "driverName",
            //               vehicleNumber: "123456789",
            //               dispatchDate: new Date(),
            //             });
            //             console.log("Submit");
            //           }}
            //         >
            //           Submit
            //         </Button>
            //         <Button
            //           color='danger'
            //           size='sm'
            //           className='me-2'
            //           onClick={() => {
            //             console.log("Export");
            //           }}
            //         >
            //           Export
            //         </Button>
            //       </div>
            //     </Col>
            //     <Col md={2}></Col>
            //   </Row>
            // }
          />
        </ModalBody>
      </Modal>
    </div>
  );
}

export default PreDispatchReports;
